<ng-container *transloco="let t">
  <div [ngClass]="[cssClass]">
    <div class=" d-flex align-items-center disabled" style="flex-wrap: wrap; height: fit-content;">
      <label for="tagsInput">{{ inputLabel }}
        @if(isRequired){
          <span>*</span>
        }
      </label>
      @if (showErrorMessage && errors) {
      @for( errorMessage of errors | errorMessages; track errorMessage){
      <span class="errorMes pt-1">{{ errorMessage }}</span>
      }
      }
      @if(showErrorMessage){
      <span class="errorMes"></span>
      }
      <div class="tags-wrapper d-flex align-items-center w-100" style="flex-wrap: wrap; gap: 4px;"
        [ngClass]="{'disabled': disabled}">
        @for(item of tags;track item; let idx = $index){
        <app-badge-with-button [ngClass]="{'disabled': disabled}" (buttonAction)="tagRemoved(idx)"
          [badgeClass]="idx === activeTag ? 'active': ''" [badgeText]="item" [item]="item" [badgeColor]="badgeColor" />
        }
        <div class="flex-grow-1">
          @if(!disabled){
          <textarea id="tagsInput" #tagsInput class="tag-input w-100 auto-grow-textarea" name="tagsInput" rows="1"
            [readonly]="readonly" (keydown)="triggerFunction($event)" [(ngModel)]="newTag"></textarea>
          }
        </div>
      </div>
    </div>
  </div>
</ng-container>